import { HandbookItem, HandbookItemType } from 'types'
import { DocEmoji } from 'components/DocEmoji/DocEmoji'
import { externalFileEmoji } from 'components/ReviewsWizard/FileSelection/urlValidationUtils'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Folder, FolderOpen2 } from 'blaze-ui/icons/20'

export const Icon = ({ item, isExpanded, size }: { item: HandbookItem; isExpanded?: boolean; size?: number }) => {
  const emoji = item.document?.header_emoji

  if (item.type === HandbookItemType.NestedHandbook)
    return isExpanded ? <FolderOpen2 size={size} /> : <Folder size={size} />

  if (item.document) {
    if (item.document.channel_emoji) return <ChannelIcon channel={item.document.channel_emoji} size={size} />

    return externalFileEmoji(item.document) || <DocEmoji emoji={item.document.header_emoji || null} />
  }

  return <>{emoji}</>
}
